<template>
    <div class="account-btn-wrap ml-auto mr-2">
        <span v-if="demo.isDemo" class="demo-nav-badge">DEMO</span>
        <Button v-if="!sm" 
            :disabled="!getAllowedNavigation()" 
            :label="profile.firstName + ' ' + profile.lastName || 'User'"
            icon="pi pi-user"
            class="nav-btn w-auto"
            @click="toggleMenu" 
            aria-haspopup="true" 
            aria-controls="user_menu"
            variant="text"
        />
        <Button v-if="sm" 
            :disabled="!getAllowedNavigation()" 
            icon="pi pi-user"
            class="nav-btn w-auto px-3"
            @click="toggleMenu" 
            aria-haspopup="true" 
            aria-controls="user_menu" 
            variant="text"
        />
        <Menu ref="menu" id="user_menu" :model="menuItems" :popup="true" />
    </div>
</template>

<script>
import { useDrawingStore } from '../../stores/drawing'
import { useUserRole } from '../../stores/userRole'
import { useUsers } from '../../stores/users'
import { useCustomers } from '../../stores/customers'
import { useDemoStore } from '../../stores/demoStore'

export default {
    name: 'AccountButton',
    props: ['sm'],
    data() {
        return {
            profile: {}
        }
    },
    setup() {
        const drawingStore = useDrawingStore()
        const userRole = useUserRole()
        const users = useUsers()
        const customers = useCustomers()
        const demo = useDemoStore()

        return {
            drawingStore,
            userRole,
            users,
            customers,
            demo,
        }
    },
    async mounted() {
        // Load user profile
        this.profile = await this.$keycloak.loadUserProfile()
    
        // Get user organization roles
        await this.userRole.getUserOrgRole(this.$keycloak)
    },
    computed: {
        menuItems() {
            return [
                {
                    label: this.$t('Profile'),
                    icon: 'pi pi-user',
                    command: () => this.profileAction()
                },
                {
                    label: this.$t('Logout'),
                    icon: 'pi pi-power-off',
                    command: () => this.logoutAction()
                },
                {
                    separator: true
                },
                {
                    label: this.$t('Language'),
                    items: [
                        {
                            label: 'English',
                            icon: 'flag-en',
                            command: () => this.changeLanguage('en')
                        },
                        {
                            label: 'Română',
                            icon: 'flag-ro',
                            command: () => this.changeLanguage('ro')
                        },
                        {
                            label: 'Deutsch',
                            icon: 'flag-de',
                            command: () => this.changeLanguage('de')
                        },
                        {
                            label: 'Українська',
                            icon: 'flag-uk',
                            command: () => this.changeLanguage('uk')
                        },
                        {
                            label: 'Português',
                            icon: 'flag-br',
                            command: () => this.changeLanguage('pt')
                        }
                    ]
                }
            ]
        },
    },
    methods: {
        toggleMenu(event) {
            this.$refs.menu.toggle(event)
        },
        profileAction() {
            this.$keycloak.accountManagement()
        },
        logoutAction() {
            this.$keycloak.logoutFn()
        },
        changeLanguage(locale) {
            this.$i18n.locale = locale
        },
        getAllowedNavigation() {
            return !this.drawingStore.getLoading()
        }
    }
}
</script>

<style lang="scss">
.p-menu-list {
    padding: 0px !important;
}

/* Make all menu items have the same padding - both main items and language items */
#user_menu .p-menu-item .p-menu-item-link {
    padding: 8px 12px !important;
    display: flex;
    align-items: center;
}

/* Custom flag icons */
.flag-en::before {
    content: '';
    display: inline-block;
    width: 28px;
    height: 21px;
    background-image: url('/flags/en.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    transform: translateY(2px);
}

.flag-ro::before {
    content: '';
    display: inline-block;
    width: 28px;
    height: 21px;
    background-image: url('/flags/ro.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    transform: translateY(2px);
}

.flag-de::before {
    content: '';
    display: inline-block;
    width: 28px;
    height: 21px;
    background-image: url('/flags/de.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    transform: translateY(2px);
}

.flag-uk::before {
    content: '';
    display: inline-block;
    width: 28px;
    height: 21px;
    background-image: url('/flags/uk.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    transform: translateY(2px);
}

.flag-br::before {
    content: '';
    display: inline-block;
    width: 28px;
    height: 21px;
    background-image: url('/flags/br.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    transform: translateY(2px);
}

/* AccountButton icon same size as other navbar icons on mobile */
@media (max-width: 767px) {
    .nav-btn .p-button-icon.pi-user {
        font-size: 1.2rem !important;
    }
}

.account-btn-wrap {
    display: flex;
    align-items: center;
    gap: 0.4rem;
}

.demo-nav-badge {
    flex-shrink: 0;
    padding: 0.15rem 0.4rem;
    border-radius: 4px;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    line-height: 1.2;
    color: #111;
    background: #f59e0b;
    user-select: none;
}
</style>
